import { render, staticRenderFns } from "./AddWeeklyReportPage.vue?vue&type=template&id=2c98a39a"
import script from "./AddWeeklyReportPage.vue?vue&type=script&lang=js"
export * from "./AddWeeklyReportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports